import { render, staticRenderFns } from "./OurFacilities.vue?vue&type=template&id=7a6ff0ea&scoped=true&"
import script from "./OurFacilities.vue?vue&type=script&lang=js&"
export * from "./OurFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ff0ea",
  null
  
)

export default component.exports